export default function authHeader() {
  const user = JSON.parse(localStorage.getItem('user'));

  if (user && user.token) {
    return { Authorization: user.token };
  } else {
    return {};
  }
}

export function authHeaderMultipart() {
  const user = JSON.parse(localStorage.getItem('user'));

  if (user && user.token) {
    return { Authorization: user.token, "Content-Type": "multipart/form-data" };
  } else {
    return {};
  }
}